import { gql } from '@/__generated__';

export const UPDATE_USER_VISIBLE_UNITS = gql(`#graphql
  mutation UpdateUserVisibleUnits($input: UpdateUserPreferencesVisibleUnitsInput!) {
    updateUserPreferencesVisibleUnits(input: $input) {
      id
      visibleUnits
    }
  }
`);

export const UPDATE_ORGANIZATION_VISIBLE_UNITS = gql(`#graphql
  mutation UpdateOrganizationVisibleUnits($input: UpdateOrganizationPreferencesVisibleUnitsInput!) {
    updateOrganizationPreferencesVisibleUnits(input: $input) {
      id
      visibleUnits
    }
  }
`);
